import AdSensePush from "@/components/AdSensePush.tsx";
import {config} from "@/config/config.ts";

/**
 * Full-width responsive banner ad that renders at ALL screen sizes — unlike the wide-only
 * (>=1850px) AdRails gutters. Drop it into the content flow of public pages so that phone and
 * laptop visitors (the large majority) actually get an ad, instead of only ultra-wide desktops.
 * Renders nothing when ads are disabled.
 */
export default function AdBanner({
    slot = config.adsenseContentSlot,
    className = "",
    labelClassName = "text-black/30",
}: { slot?: string; className?: string; labelClassName?: string }) {
    if (!config.adsenseEnabled) {
        return null;
    }

    return (
        <div className={`mx-auto w-full max-w-4xl px-4 ${className}`}>
            <div className={`mb-1 text-center text-[10px] uppercase tracking-[0.2em] ${labelClassName}`}>Advertisement</div>
            <AdSensePush>
                <ins
                    className="adsbygoogle"
                    style={{display: "block", minHeight: 90}}
                    data-ad-client={config.adsenseClient}
                    data-ad-slot={slot}
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                />
            </AdSensePush>
        </div>
    );
}
